import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from 'investira.react.components';

/**
 * Renderiza o componente PlusIconButton.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.size - Tamanho aplicado ao componente ou ícone.
 * @param {string} props.color - Cor usada na renderização do componente.
 * @param {Function} props.onClick - Callback executado ao clicar no componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const PlusIconButton = memo(props => {
    const { onClick, size, color } = props;

    return (
        <IconButton onClick={onClick}>
            <Icon iconName="insert" size={size} color={color} />
        </IconButton>
    );
});

PlusIconButton.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    onClick: PropTypes.func
};

PlusIconButton.defaultProps = {
    size: 22,
    color: 'primary'
};

export default PlusIconButton;
